module.exports = __webpack_public_path__ + "img/08.ebf1e602.jpg";